import React, { useMemo } from 'react';
import { View, Text, StyleSheet, Pressable, ImageBackground, ScrollView, Dimensions, Image } from 'react-native';
import { Spacing, Mixins, Typography, Colors } from '@styles';
import { useTheme } from '@themeProvider';
import { useLanguage } from '@languageProvider';
import { Button, GeneralTag, BaseAvatar } from '@atoms';
import { parsePrice } from '@utils/helpers';
import { SmartFlatGridView, SmartWrapView } from '@lib';
import { Promotion, ProductNode, SelectionTree, Coupon } from '@datamodel';

const PackItem = ({ packItem, style, photoStyle, ...props }) => {
    const { useColor } = useTheme();
    const [body, title, primary] = useColor(['body', 'title']);

    // const contrastedPrimary = Colors.withMinimumWhiteContrast(primary, 18);

    return <View style={[Mixins.HORIZONTAL, { alignItems: 'center' }, style]} {...props}>
        <ImageBackground source={{ uri: packItem.product.photo }} style={[photoStyle, { height: 40, width: 40, overflow: 'hidden', alignItems: 'center', justifyContent: 'center' }]}>
            <View style={[StyleSheet.absoluteFill, { backgroundColor: Colors.setOpacity(title, .35) }]} />
            <Text style={[Typography.TITLE, { color: 'white', textAlign: 'center', zIndex: 1 }]}>{packItem.quantity}</Text>
        </ImageBackground>
        <Text style={[Typography.SMALL_COPY, { color: body, marginLeft: Spacing.XS }]}>{packItem.product.name}</Text>
    </View>
}

export const ProductPackCard = ({ pack, style, cartCount, ...props }) => {
    const { useColor, useElevation } = useTheme();
    const elevation = useElevation(4);
    const rounding = Mixins.rounding(88);
    const [title, body, primary, primaryText, line, label, backgroundColor] = useColor([
        'title',
        'body',
        'primary',
        ['primary', { isText: true }],
        'line',
        'label',
        'background',
    ])

    const [numberColor] = useColor([
        ['title', { on: primary }]
    ]);

    const packItems = Object.keys(pack.items).map(id => pack.items[id]);

    const [price, originalPrice] = useMemo(() => {
        return Object.keys(pack.items).reduce((acc, itemId) => {
            const item = pack.items[itemId];
            const fromPrice = ProductNode.calculateTreeFromPrices(item.product);

            // TODO: Check this
            let unitPrice = item.product.maxChildren === 0 ? item.product.price.amount : fromPrice[item.product.nodeId] + item.product.price.amount;
            let itemPrice = unitPrice * item.quantity;
            let ogItemPrice = itemPrice;
            if (item.coupon) {
                itemPrice = Coupon.discountedPrice(item.coupon, ogItemPrice);
            }
            return [acc[0] + itemPrice, acc[1] + ogItemPrice];
        }, [0, 0]);
    });

    return <Pressable style={[elevation, rounding, style]} {...props}>
        <View style={[Mixins.HORIZONTAL, { borderBottomWidth: 1, borderColor: line }]}>
            <Image style={{ width: 88, borderTopLeftRadius: rounding.borderRadius }} source={{ uri: pack.photo }} />
            <View style={{ marginLeft: Spacing.M, paddingVertical: Spacing.XS, flex: 1 }}>
                <Text style={[Typography.TITLE, { color: title }]}>{pack.name}</Text>
                <Text style={{ textAlignVertical: 'bottom' }}>
                    <Text style={[Typography.TITLE, { color: false && soldOut ? label : primaryText }]}>{parsePrice(price, '€')}  </Text>
                    {price < originalPrice &&
                        <Text style={[Typography.TITLE, { color: label, textDecorationLine: 'line-through' }]}>{parsePrice(originalPrice, '€')}</Text>
                    }
                </Text>

            </View>
        </View>

        <Text style={[Typography.SUBTITLE, { color: body, marginHorizontal: Spacing.S, marginTop: Spacing.XS }]}>{pack.description}</Text>
        <SmartWrapView flexDirection='row' crossDirectionSize={40 + Spacing.XS} style={{ marginBottom: Spacing.S }}>
            {packItems.map(packItem => <PackItem key={packItem.itemId} style={{ marginLeft: Spacing.S, marginTop: Spacing.XS }} packItem={packItem} photoStyle={Mixins.matchRounding(rounding, -Spacing.S)} />)}
        </SmartWrapView>

        {cartCount >= 1 &&
            <View
                style={{
                    borderWidth: 2,
                    borderColor: backgroundColor,
                    width: Typography.SMALL_COPY.lineHeight * 1.3,
                    height: Typography.SMALL_COPY.lineHeight * 1.3,
                    ...Mixins.rounding(Typography.SMALL_COPY.lineHeight * 1.3),
                    backgroundColor: primary,
                    justifyContent: 'center',
                    position: 'absolute',
                    bottom: -1 / 4 * 1.3 * Typography.SMALL_COPY.lineHeight,
                    right: -1 / 4 * 1.3 * Typography.SMALL_COPY.lineHeight,
                }}
            >
                <Text style={[Typography.STRONG, { textAlign: 'center', color: numberColor, fontSize: Typography.SMALL_COPY.fontSize }]}>{cartCount}</Text>
            </View>
        }

    </Pressable>
}
